import { themeVariables } from "Components/theme";
export const NAV_ITEM_CLASS_NAME = "sidebar-nav-item";
export const NAV_ITEM_HAS_SUB_ITEMS_CLASS_NAME = "sidebar-nav-item-group";
export const NAV_ITEM_SELECTED_CLASS_NAME = "sidebar-nav-item-selected";
export const NAV_ITEM_ACTIVE_CLASS_NAME = "sidebar-nav-item-active";
export const NAV_ITEM_DISABLED_CLASS_NAME = "sidebar-nav-item-disabled";
export const NAV_MB_DEFAULT_GAP_CLASS_NAME = "sidebar-nav-item-mb-default-gap";
export const NAV_CENTERED_CONTENT_CLASS_NAME = "sidebar-nav-item-centered-content";
export const NAV_ITEM_ACTION_PANEL_CLASS_NAME = "sidebar-nav-item-action-panel";
export const NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME = "sidebar-nav-item-element-ignore-styles";
export const progressOverlayStyle = {
    opacity: 0.7,
    filter: "blur(3em)",
    backgroundColor: themeVariables["navbar-bg"],
    borderRadius: themeVariables["border-radius-base"]
};
